// Queries

export const getSavedSearches = `{
  searches {
    mySearches {
      id description createdAt updatedAt name ownerId params userGroup userId sharedWith
    }
  }
}`;

// Mutations

// $addsavedsearchinput { params: {}!, name: ""!, description: ""!, ownerId: ""!, sharedWith: ""! }
export const addSavedSearch = `mutation AddSearch ($addsavedsearchinput: AddSearchInput!) { 
  addSearch(input: $addsavedsearchinput) {
    id
  }
}`;

// $updatesavedsearchinput { id: ""!, params: {}, name: "", description: "", ownerId: "", sharedWith: "" }
export const updateSavedSearch = `mutation UpdateSearch ($updatesavedsearchinput: UpdateSearchInput!) { 
  updateSearch(input: $updatesavedsearchinput) {
    id description createdAt name ownerId params sharedWith userGroup userId
  }
}`;

// $sharesavedsearchid: String!, $sharesavedsearchsharedwith: [String!]!
export const shareSavedSearch = `mutation ShareSearch ($sharesavedsearchid: String!, $sharesavedsearchsharedwith: [String!]!) { 
  shareSearch(id: $sharesavedsearchid, sharedWith: $sharesavedsearchsharedwith) {
    id
  }
}`;

// $deletesavedsearchid: ""!
export const deleteSavedSearch = `mutation DeleteSearch ($deletesavedsearchid: String!) { 
  deleteSearch(id: $deletesavedsearchid)
}`;
